import { useAuthContext } from '../contexts/authContext';
export const useAuth = () => useAuthContext();
